import { Component, HostListener, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../../environments/environment";
import { AuthService } from "../../../auth/auth.service";
import { Subscription } from "rxjs";
import { AuthMsgService } from "../../../auth/auth-msg.service";
import { LogoUpdateService } from "../../../services/logo-update.service";
import { UserProfile } from "../../../models/userprofile";
import { Router } from "@angular/router";
import { SidenavService } from "../../../services/side-bar.service";
import { OrgSettingsService } from "../../../org-settings/org-settings.service";
import { OrganisationMemberDTO } from "../../../DTOs/Organisations/Models/OrganisationMemberDTO";
import { OrganisationDTO } from "../../../DTOs/Organisations/Models/OrganisationDTO";
import Cookies from "universal-cookie";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  public enUS: string = "en-US";
  public enAU: string = "en-AU";
  public enGB: string = "en-GB";
  public esES: string = "es-ES";
  public itIT: string = "it-IT";
  public plPL: string = "pl-PL";
  public ptPT: string = "pt-PT";

  public innerWidth: number;
  public langSelected: string = "en-US";
  public langSelectedShort: string = "US";
  sub: Subscription;
  subAuth: Subscription;
  subLogo: Subscription;
  public IsAuthenticated: boolean = false;
  public UserId: string = "";
  public UserNameTitle: string = "";
  public userProfile: UserProfile;
  public UserFirstName: string;
  public UserLastName: string;
  public UserEmail: string;
  public memberDTO: OrganisationMemberDTO = new OrganisationMemberDTO();
  public OrgId: string = "";
  public LogoUrl: string = "";
  public Subscriptions: string[] = [];
  public Integrations: string[] = [];
  public UserflowTag: string = "";
  public UserflowIntegrationTag: string = "";
  public UserflowSubscriptionTag: string = "";

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private authMsgService: AuthMsgService,
    private logoUpdateService: LogoUpdateService,
    private router: Router,
    private sidenavService: SidenavService,
    private orgSettingService: OrgSettingsService,
  ) {
    let enUS: string = "en-US";
    let enAU: string = "en-AU";
    let enGB: string = "en-GB";
    let esES: string = "es-ES";
    let itIT: string = "it-IT";
    let plPL: string = "pl-PL";
    let ptPT: string = "pt-PT";

    this.translate.addLangs([enUS, enAU, enGB, esES, itIT, plPL, ptPT]);

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang(enUS);

    const browserLang = this.translate.getBrowserLang();

    let browserFullLang = [enUS, enAU, enGB, esES, itIT, plPL, ptPT].find((x) =>
      x.startsWith(browserLang)
    );
    if (!browserFullLang) browserFullLang = "en-US";

    let availLang: string =
      "/" + enUS + "|" + enAU + "|" + enGB + "|" + esES + "|" + itIT + "|" + plPL  + "|" + ptPT + "/";

    if (environment.debug_mode)
      console.log("Available Languages: " + availLang);

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    //translate.use(browserLang.match(/en-US|en-AU|en-GB|es-ES|it-IT/) ? browserLang : 'en-US');

    this.translate.use(browserFullLang);
    this.langSelected = browserFullLang;
    this.langSelectedShort = this.langSelected.substring(3);

    // subscribe to home component messages
    /*
        this.sub = this.localisation.get()
        .subscribe(message => {
            this.enUS = message[0] as string;
            this.enAU = message[1] as string;
            this.enGB = message[2] as string;
            this.esES = message[3] as string;
            this.itIT = message[4] as string;

            this.translate.use(this.enUS);

            if (environment.debug_mode)
                console.log("Header loaded es-US: " + this.enUS);

        });
        */

    this.subLogo = this.logoUpdateService.getMessage().subscribe((message) => {
      if (environment.debug_mode) {
        console.log("HeaderComponent, logoUpdateService, LogoUrl: " + message);
      }

      this.LogoUrl = message;
    });

    this.subAuth = this.authMsgService.getMessage().subscribe((message) => {
      this.IsAuthenticated = message as boolean;
      {
        if (environment.debug_mode)
          console.log(
            "HeaderComponent, this.IsAuthenticated=" + this.IsAuthenticated
          );
      }

      //if (this.authService.isLoggedIn()) {
        this.authService.getClaims$().subscribe(claims => {
          if (!claims) return;
          this.initHeader(claims, browserFullLang);
        });
      //}
    });
  }

  private initHeader(claims: UserProfile, browserFullLang: string) {
    this.userProfile = claims;
    this.UserId = this.userProfile.sub;
    this.OrgId = this.userProfile.organization_id;

    //Set Default Colours, in case getOrganisation does not responde
    let primaryColor: string = "#3B5999";
    let secondaryColor: string = "#a43131";
    const cookies = new Cookies();
    cookies.set("primaryColor", primaryColor, { path: "/" });
    cookies.set("secondaryColor", secondaryColor, { path: "/" });

    //--------------------------------------------
    // Load Organisation Colors - begin
    //--------------------------------------------
    this.orgSettingService.getOrganisation(this.OrgId).subscribe(
      (response: OrganisationDTO) => {
        if (response.PrimaryColor != undefined &&
          response.PrimaryColor != "") {
          primaryColor = response.PrimaryColor;
        }

        if (response.SecondaryColor != undefined &&
          response.SecondaryColor != "") {
          secondaryColor = response.SecondaryColor;
        }

        this.Subscriptions = response.Subscriptions.filter(x => x.isEnabled).sort().map(x => x.type.toLowerCase());
        this.Integrations = response.Wizards.map(x => x.type.toLowerCase());
        if (this.Integrations.length <= 0) {
          this.Integrations.push('standalone');
        }
        if (this.Subscriptions.length <= 0) {
          this.Subscriptions.push('nosubscription');
        }
        var tag = "userflow-";
        this.Integrations.forEach(int => {
          tag = tag + int + "-";
          this.Subscriptions.forEach(sub => {
            tag = tag + sub + "-";
          });
        });
        this.UserflowTag = tag;

        tag = "userflow-integration-";
        this.Integrations.forEach(int => {
          tag = tag + int + "-";
        });
        this.UserflowIntegrationTag = tag;

        tag = "userflow-subscription-";
        this.Subscriptions.forEach(sub => {
          tag = tag + sub + "-";
        });
        this.UserflowSubscriptionTag = tag;

        //const cookies = new Cookies();
        cookies.set("primaryColor", primaryColor, { path: "/" });
        cookies.set("secondaryColor", secondaryColor, { path: "/" });

        if (environment.debug_mode) {
          console.log(
            "Organisation Primary Color: " + response.PrimaryColor
          );
          console.log(
            "Organisation Secondary Color: " + response.SecondaryColor
          );
          console.log(
            "Organisation Primary Color: " + cookies.get("primaryColor")
          );
          console.log(
            "Organisation Secondary Color: " + cookies.get("secondaryColor")
          );
          console.log(
            "Organisation Logo LogoUrl: " + response.Logo.LogoUrl
          );
        }

        this.LogoUrl = response.Logo.LogoUrl;
      },

      (error) => {
        console.error(error);
      }
    );

    //--------------------------------------------
    // Load  Organisation Colors - end
    //--------------------------------------------
    //--------------------------------------------
    // Load Member - begin
    //--------------------------------------------
    this.orgSettingService
      .getOrganisationMember(this.UserId, this.UserId)
      .subscribe(
        (response: OrganisationMemberDTO) => {
          this.memberDTO = response;
          cookies.set("memberId", this.memberDTO.Id, { path: "/" });
          this.UserFirstName = this.memberDTO.FirstName;
          this.UserLastName = this.memberDTO.LastName;
          this.UserEmail = this.memberDTO.Email;

          if (this.memberDTO.Language == undefined) {
            this.translate.use(browserFullLang);
            this.langSelected = browserFullLang;
            this.langSelectedShort = this.langSelected.substring(3);
          } else {
            this.translate.use(this.memberDTO.Language);
            this.langSelected = this.memberDTO.Language;
            this.langSelectedShort = this.langSelected.substring(3);
          }
          this.authService.updateUserLanguage(this.langSelected);
          if (environment.debug_mode) {
            console.log(
              "getOrganisationMember, response: " + JSON.stringify(response)
            );
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  changeLang(langSelected: string): void {
    if (environment.debug_mode)
      console.log("Language selected: " + langSelected);

    this.translate.use(langSelected);
    this.langSelectedShort = langSelected.substring(3);

    this.orgSettingService
      .changeMemberLanguage(this.UserId, langSelected)
      .subscribe(
        (response) => { 

          this.authService.updateUserLanguage(langSelected);
          window.location.reload();
        },
        (error) => { }
      );
  }

  openProfile(): void {
    if (environment.debug_mode) {
      console.log("Clicked on Profile Setting & Notifications");
    }
  }

  openLogin(): void {
    if (environment.debug_mode) {
      console.log("Clicked on Login");
    }
    this.router.navigate(["/login"]);
  }

  openLogoff(): void {
    if (environment.debug_mode) {
      console.log("Clicked on Logoff");
    }
    this.router.navigate(["/logoff"]);
  }

  ngOnDestroy(): void {
    // unsubscribe to ensure no memory leaks
    this.sub.unsubscribe();
    this.subAuth.unsubscribe();
    this.subLogo.unsubscribe();
  }

  toggleSidenav() {
    this.sidenavService.toggle();
  }
}
